<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">
                        <a @click="$router.push('/recobro-menu')" class="ml-2 cursor-pointer">
                            <i class="fa fa-arrow-left"></i></a>
                        <span class="ml-3">Búsqueda Re-cobros</span>
                    </h4>
                    <div class="m-b-30 card-container">
                        <div class="card-body">
                            <div class="general-label">
                                <!--<div class="form-group">
                                    <label>Búsqueda por NIT</label>
                                    <input type="text" class="form-control" placeholder="Escriba aquí" v-model="searchNit">
                                </div>-->
                                <div class="form-group">
                                    <label>Ingrese información para buscar</label>
                                    <div class="mt-3">
                                        Buscar por: <br>
                                        <select v-model="typesearch" class="form-control">
                                            <option value="recobro" selected>Recobro</option>
                                            <option value="reclamo">Reclamo</option>
                                            <option value="placa">Placa</option>
                                        </select>
                                    </div>
                                    <div class="mt-3">
                                        <div v-if="typesearch === 'recobro'">
                                            <div class="mt-1">
                                                <span class="mt-1">Ingrese No.Re-cobro</span>
                                                <input ref="searchOne" type="tel" class="form-control" placeholder="Escriba aquí" v-model="searchValue" v-on:keyup.enter="preSearch">
                                            </div>
                                            <div class="mt-2">
                                                <span>Seleccione Moneda</span>
                                                <select v-model="searchExtraUno" class="form-control">
                                                    <option value="Q" selected>Quetzales</option>
                                                </select>
                                            </div>
                                            <div class="mt-2">
                                                <span class="mt-2">Seleccione Ramo</span>
                                                <select v-model="searchExtraDos" class="form-control">
                                                    <option value="91" selected>91 - Vehiculos</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div v-if="typesearch === 'placa'">
                                            <div class="mt-1">
                                                <span class="mt-1">Ingrese No.Placa</span>
                                                <input ref="searchOne" type="text" class="form-control" placeholder="Escriba aquí" v-model="searchValue" v-on:keyup.enter="preSearch">
                                            </div>
                                            <div class="mt-2">
                                                <span>Seleccione Moneda</span>
                                                <select v-model="searchExtraUno" class="form-control">
                                                    <option value="Q" selected>Quetzales</option>
                                                </select>
                                            </div>
                                            <div class="mt-2">
                                                <span class="mt-2">Seleccione Ramo</span>
                                                <select v-model="searchExtraDos" class="form-control">
                                                    <option value="91" selected>91 - Vehiculos</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div v-if="typesearch === 'reclamo'">
                                            <div class="mt-1">
                                                <span class="mt-1">Ingrese No.Reclamo</span>
                                                <input ref="searchOne" type="tel" class="form-control" placeholder="Escriba aquí" v-model="searchValue" v-on:keyup.enter="preSearch">
                                            </div>
                                            <div class="mt-2">
                                                <span>Seleccione Moneda</span>
                                                <select v-model="searchExtraUno" class="form-control">
                                                    <option value="Q" selected>Quetzales</option>
                                                </select>
                                            </div>
                                            <div class="mt-2">
                                                <span class="mt-2">Seleccione Ramo</span>
                                                <select v-model="searchExtraDos" class="form-control">
                                                    <option value="91" selected>91 - Vehiculos</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--<h5 class="text-primary">Otros</h5>
                                <div class="form-group">
                                    <label>No.Póliza</label>
                                    <input type="text" class="form-control" placeholder="Escriba aquí">
                                </div>
                                <div class="form-group">
                                    <label>No.Requerimiento</label>
                                    <input type="text" class="form-control" placeholder="Escriba aquí">
                                </div>-->
                                <div class="text-right d-flex gap-2 flex-wrap justify-content-end">
                                    <button @click="searchValue = ''; recobros = {}; $refs.searchOne.focus()" type="button" class="btn btn-warning btn__limpiar">Limpiar</button>
                                    <button @click="preSearch" type="button" class="btn btn-primary btn__buscar">Buscar</button>
                                </div>
                            </div>
                            <div class="searchResultContainer">
                                <div class="searchResult" v-if="recobros.poliza && parseInt(recobros.poliza) > 0">
                                    <div>
                                        <h5 class="text-primary">
                                            Información de Re-Cobro
                                        </h5>
                                    </div>
                                    <div v-if="!recobros.error">
                                        <div class="row">
                                            <div class="col-6" v-if="typeof recobros.notaTec !== 'undefined'">
                                                <span class="font-weight-bold">Nota técnica:</span> {{(recobros.notaTec) ? recobros.notaTec : 'N/D'}}
                                            </div>
                                            <div class="col-6" v-if="typeof recobros.recobro !== 'undefined'">
                                                <span class="font-weight-bold">Recobro:</span> {{(recobros.recobro) ? recobros.recobro : 'N/D'}}
                                            </div>
                                            <div class="col-6" v-if="typeof recobros.reclamo !== 'undefined'">
                                                <span class="font-weight-bold">Reclamo:</span> {{(recobros.reclamo) ? recobros.reclamo : 'N/D'}}
                                            </div>
                                            <div class="col-12">
                                                <span class="font-weight-bold">Nombre culpable:</span> {{(recobros.nombreCulpable) ? recobros.nombreCulpable : 'N/D'}}
                                            </div>
                                            <div class="col-6">
                                                <span class="font-weight-bold">Reclamo:</span> {{(recobros.reclamo) ? recobros.reclamo : 'N/D'}}
                                            </div>
                                            <div class="col-6">
                                                <span class="font-weight-bold">Póliza:</span> {{(recobros.poliza) ? recobros.poliza : 'N/D'}}
                                            </div>
                                            <div class="col-6">
                                                <span class="font-weight-bold">Ramo:</span> {{(recobros.ramo) ? recobros.ramo : 'N/D'}}
                                            </div>
                                            <div class="col-6">
                                                <span class="font-weight-bold">Moneda:</span> {{(recobros.moneda) ? recobros.moneda : 'N/D'}}
                                            </div>
                                            <div class="col-6">
                                                <span class="font-weight-bold">Fecha Siniestro:</span> {{(recobros.fechaSiniestro) ? recobros.fechaSiniestro : 'N/D'}}
                                            </div>
                                        </div>
                                        <div v-if="recobros.notaTec !== 'N' && recobros.aCrear" class="mt-3">
                                            <div v-if="recobros.monto">
                                                <div class="text-danger">
                                                    Este re-cobro contiene una nota técnica, debe crearlo a partir del monto de la nota.
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col-6">
                                                        <span class="font-weight-bold">Monto:</span> {{(recobros.moneda) ? recobros.moneda : 'N/D'}} {{(recobros.monto) ? recobros.monto : 'N/D'}}
                                                    </div>
                                                </div>
                                                <div class="mt-2">
                                                    <button class="btn btn-sm btn-primary" @click="crearRecobroNt(recobros)">Crear Recobro</button>
                                                </div>
                                            </div>
                                            <div v-else class="text-danger">
                                                Este recobro no contiene monto, posiblemente ya está pagado
                                            </div>
                                        </div>
                                        <div v-if="recobros.notaTec === 'N' && recobros.aCrear" class="mt-3">
                                            <div class="mt-2">
                                                <button class="btn btn-sm btn-primary" @click="crearRecobroNt(recobros)">Crear Re-cobro con este reclamo</button>
                                            </div>
                                        </div>
                                        <div v-if="typeof recobros.listaPagos !== 'undefined' && recobros.listaPagos.length > 0">
                                            <div>
                                                <hr>
                                                <h5 class="text-primary my-2">
                                                    Listado de pagos
                                                </h5>
                                            </div>
                                            <div v-if="typesearch === 'recobro' || typesearch === 'reclamo' || typesearch === 'placa'">
                                                <div v-for="item in recobros.listaPagos" class="resultItem">
                                                    <div class="font-weight-bold mb-2">
                                                        {{ item.prNomcli }}
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <span class="font-weight-bold">No. Pago:</span> {{(item.numeroPago) ? item.numeroPago : 'N/D'}}
                                                        </div>
                                                        <div class="col-6">
                                                            <span class="font-weight-bold">Fecha:</span> {{(item.fechaPago) ? item.fechaPago : 'N/D'}}
                                                        </div>
                                                        <div class="col-6">
                                                            <span class="font-weight-bold">Monto:</span> {{(item.montoCiva) ? item.montoCiva : 'N/D'}}
                                                        </div>
                                                        <div class="col-6">
                                                            <span class="font-weight-bold">Monto Sin IVA:</span> {{(item.montoPago) ? item.montoPago : 'N/D'}}
                                                        </div>
                                                        <div class="col-6">
                                                            <span class="font-weight-bold">Estatus:</span> {{(item.statusPago) ? (typeof item.statusPago === 'string' ? item.statusPago : '') : 'N/D'}}
                                                        </div>
                                                        <div class="col-6">
                                                            <span class="font-weight-bold">Recibo:</span> {{(item.recibo) ? item.recibo : 'N/D'}}
                                                        </div>
                                                        <div class="col-12 mt-3" v-if="!parseInt(item.recibo)">
                                                            <inicio-pago typepago="recobro" :pago-pendiente="(typeof item.pPnd !== 'undefined') ? item.pPnd : 0" :onlyfact="(typeof item.pLF !== 'undefined') ? item.pLF : 'none'" :pago-log="(typeof item.pL !== 'undefined') ? item.pL : false" :item="{tipo: 'recobro', moneda: recobros.moneda, monto: item.montoCiva, montoCIva: item.montoCiva, montoSiva: item.montoPago,  nit: '', asegurado: recobros.nombreCulpable, poliza: recobros.poliza, requerimiento: 0, reclamo: recobros.reclamo, ramo: recobros.ramo, noPago: item.numeroPago, recobro: recobros.recobro}" bloqueoaplicar="true"></inicio-pago>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="searched && Object.keys(recobros).length === 0" class="text-center text-muted">
                                                No se encontraron pagos
                                            </div>
                                        </div>
                                        <div v-else class="text-center text-muted mt-3">
                                            Sin listado de pagos
                                        </div>
                                    </div>
                                    <div v-else>
                                        {{recobros.error}}
                                    </div>
                                </div>
                                <div v-else class="text-center text-muted">
                                    No se encontró información relacionada con esta búsqueda
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../../global/components/Layout";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import Pago from "src/modules/pos/views/Pago";
import InicioPago from "src/modules/pos/views/components/InicioPago";


export default {
    props: {},
    components: {
        Pago,
        //TimelineChart,
        Layout,
        //Toster,
        InicioPago
    },
    data() {
        return {
            Valid: {},
            searchExtraUno: "Q",
            searchExtraDos: "91",
            searchValue: "",
            typesearch: "recobro",
            searched: false,
            recobros: {},

            // para pago directo
            pagar: 0,
            tipoPago: '',
            nit: '',
            nombre: '',
            direccion: '',
            polizaNo: '',

            // para pago
            pagandoref: 0,
            pagosToApply: {}
        };
    },
    mounted() {
        if (!Tools.tieneParamsBusquedaRuta(this.$route.params)) {
            return;
        }
        this.searchValue = this.$route.params.search;
        this.typesearch = this.$route.params.type;
        this.searchExtraUno = this.$route.params.extra;
        this.searchExtraDos = this.$route.params.extrados;
        this.search();
    },
    methods: {
        Numbro,
        dayjs,
        search() {

            const self = this;
            this.recobros = {};

            let url = 'recobro/busqueda?s=' + self.searchValue + '&m=' + self.searchExtraUno+ '&r=' + self.searchExtraDos + '&t=' + self.typesearch;

            store.dispatch('coreShowLoading');

            API.send('GET', url, null,
                function (response) {
                    store.dispatch('coreHideLoading');

                    if (response.status) {
                        self.recobros = (typeof response.data === "object") ? response.data : {};

                        console.log(self.recobros);

                        self.searched = true;
                    }
                    else {
                        self.searched = true;
                        alert(response.msg);
                    }

                },
                function () {
                    self.searched = true;
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                })
        },
        preSearch() {

            if (parseInt(this.searchValue) === 0 || Tools.isEmptyString(this.searchValue)) {
                return false;
            }

            if (this.typesearch === 'recobro') {
                if (this.searchValue === '' || this.searchExtraUno === '' || this.searchExtraDos === '') {
                    alert('Ingrese todos los campos');
                    return false;
                }
                this.$router.push({path: '/recobro/recobro/' + this.searchValue + '/' + this.searchExtraUno+ '/' + this.searchExtraDos});
            }
            else if (this.typesearch === 'placa') {
                if (this.searchValue === '' || this.searchExtraUno === '' || this.searchExtraDos === '') {
                    alert('Ingrese todos los campos');
                    return false;
                }
                this.$router.push({path: '/recobro/placa/' + this.searchValue + '/' + this.searchExtraUno+ '/' + this.searchExtraDos});
            }
            else if (this.typesearch === 'reclamo') {
                if (this.searchValue === '' || this.searchExtraUno === '' || this.searchExtraDos === '') {
                    alert('Ingrese todos los campos');
                    return false;
                }
                this.$router.push({path: '/recobro/reclamo/' + this.searchValue + '/' + this.searchExtraUno+ '/' + this.searchExtraDos});
            }
            //this.$forceUpdate();
            this.search();
        },
        showPago(requerimiento, tipoPago) {
            this.nit = requerimiento.nit;
            this.nombre = requerimiento.asegurado;
            this.direccion = requerimiento.direccion;
            this.pagar = requerimiento.requerimiento;
            this.poliza = requerimiento.poliza;
            this.tipoPago = tipoPago;
        },
        /*activarPagandoRef(data) {
            this.pagandoref = data;
        },*/
        cancelarPago() {
            this.pagar = 0;
        },
        crearRecobroNt(recobros) {

            if (typeof recobros.notaTec !== 'undefined') {
                const descuentos = JSON.stringify(recobros.listaDescuentos);
                let reclamo = '';
                if (typeof recobros.reclamo !== 'undefined') {
                    reclamo = recobros.reclamo;
                }

                const notaT = (recobros.notaTec === 'N') ? 0 : 1;

                this.$router.push('/recobro-crear?nt='+notaT+'&m=' + recobros.monto + '&r=' + reclamo + '&d=' + window.btoa(descuentos));
            }
            else {
                this.$router.push('/recobro-crear?nt=0&m=0&d=0&r='+recobros.reclamo);
            }
        }
    },
};
</script>
